/**
 * A custom error returned by the PaymentClient when a payment has failed.
 * Includes a resultCode that can be used to display error-appropriate UI.
 */ export class PaymentFailedError extends Error {
    constructor(resultCode){
        super();
        this.resultCode = resultCode;
    }
}

//# sourceMappingURL=payment-failed-error.js.map